import { isProductCustomisable } from './ProductPage.utils'
import { TPageState, TPageVariant } from './useProductPageVariation'
import { ProductVariant } from 'app/(main)/(catalog)/upload/[slug]/_components/designUpload/types'
import { IProductEntry } from 'app/_services/CMS/contentful/types/productEntry'

export function useProductPageState(
  productVariants: ProductVariant[],
  productData: IProductEntry
): {
  pageState: TPageState
  pageVariant: TPageVariant
} {
  const { productSlug, productType, comingSoonState, isPlusProductAvailable } =
    productData
  let pageState: TPageState = 'unavailable'
  let pageVariant: TPageVariant = 'custom'

  if (productType === 'Plus') {
    if (
      isPlusProductAvailable === true ||
      isPlusProductAvailable === undefined
    ) {
      pageState = 'available'
    }
    pageVariant = 'plus'
  } else {
    pageVariant = isProductCustomisable(productSlug) ? 'custom' : 'stock'

    if (comingSoonState) {
      pageState = 'coming-soon'
    } else if (productVariants?.length > 0) {
      pageState = 'available'
    }
  }

  return { pageState, pageVariant }
}
